import PropTypes from "prop-types";
import ButtonVariantType from "./ButtonVariantType";

export default function ButtonSetupProps() {
  return {
    title: PropTypes.string.isRequired,
    variant: ButtonVariantType()
  };
}
